export const SET_LOGO_REVIEW_QUEUE = 'setLogoReviewQueue';
export const SET_LOGO_REVIEW_STATS = 'setLogoReviewStats';
export const SET_LOGO_REVIEW_CANDIDATES = 'setLogoReviewCandidates';
export const REMOVE_LOGO_REVIEW_ITEM = 'removeLogoReviewItem';
